var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-builder-table"},[(_vm.showRetry)?_c('CardApiError',{on:{"retry":_vm.setDataTable}}):_c('Card',{attrs:{"is-loading":_vm.loading,"no-padding":""}},[_c('TableWidget',{attrs:{"columns":_vm.columns,"content":_vm.data,"default-sort":_vm.defaultSort}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }